import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import Header from "./Header";
import ChatContainer from "./ChatContainer";
import ExcerptsContainer from "./ExcerptsContainer";
import CloseIcon from "@mui/icons-material/Close";

const ChatUI = ({ token }) => {
  const [showExcerpts, setShowExcerpts] = useState(false);
  const [expandedFileRefId, setExpandedFileRefId] = useState(false)
  const [annotations, setAnnotations] = useState([]);
  const [isLoadingAnnotations, setIsLoadingAnnotations] = useState(false);

  const handleNewMessage = () => {
    setIsLoadingAnnotations(true);
    setTimeout(() => {
      setAnnotations([]);
    }, 150);
  };

  const handleShowExcerpts = (bool) => {
    setShowExcerpts(bool)
  }

  const handleAnnotations = (newAnnotations) => {
    setIsLoadingAnnotations(false);
    setAnnotations(newAnnotations);
  };

  return (
    <Box display="flex" flexDirection="column" height="98vh">
      <Box width="100%" sx={{ flex: "0 0 auto" }}>
        <Header token = {token}/>
      </Box>

      <Box display="flex" flex="1 1 auto" width="100%" position="relative" overflow="hidden">
        <Box
          flexGrow={1}
          overflow="auto"
          sx={{ transition: "margin-right 0.3s ease" }}
          mr={showExcerpts ? "30%" : 0}
        >
          <ChatContainer 
            token={token} 
            onAnnotations={handleAnnotations}
            onNewMessage={handleNewMessage}
            onShowExcerpts={handleShowExcerpts}
            setExpandedFileRefId={setExpandedFileRefId}
            setShowExcerpts={setShowExcerpts}
            showExcerpts={showExcerpts}
          />
        </Box>


          {showExcerpts ? 
          <IconButton
          onClick={() => handleShowExcerpts(!showExcerpts)}
          sx={{
            position: "absolute",
            top: 13,
            right: showExcerpts ?  {xs: "3%", sm: "3%", md: "31svw"} : 16,
            zIndex: 10,
            backgroundColor: "#fff",
            boxShadow: 1,
            transition: "right 0.3s ease",
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
          : null}

        <Box
          position="absolute"
          right={0}
          top={0}
          height="96%"
          width={{ xs: "92%", sm: "92%", md: "30%" }}
          bgcolor="#f5f5f5"
          borderLeft= {{md: "1px solid #ddd"}}
          borderRadius={{xs: "25px", sm: "25px"}}
          p={2}
          sx={{
            transform: showExcerpts ? "translateX(0)" : "translateX(100%)",
            transition: "transform 0.3s ease",
            overflowY: "auto",
            pointerEvents: showExcerpts ? "auto" : "none",
            zIndex: 9,
            boxShadow: {
              xs: "none",
              sm: "none",
              md: "-4px 0 10px -2px rgba(0,0,0,0.1)", // left-side shadow only
            },
          }}
        >
          <ExcerptsContainer 
            annotations={annotations} 
            isLoading={isLoadingAnnotations}
            expandedFileRefId={expandedFileRefId}
            setExpandedFileRefId={setExpandedFileRefId}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ChatUI;